import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import CompensationIndexPage from 'buyside/components/presentation/CompensationIndexPage/compensationIndexPage';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';

import { compensationsUrl } from 'buyside/util/urlHelper';

const CompensationIndexPageRoot: FC = () => {
  return (
    <Router basename={compensationsUrl()}>
      <ErrorBoundary pageName="the compensation page">
        <CompensationIndexPage />
      </ErrorBoundary>
    </Router>
  );
};

export default CompensationIndexPageRoot;
